import React, { useState } from "react"
import {
  FaFacebook,
  FaInstagram,
  FaYoutube,
  FaPodcast,
  FaSoundcloud,
} from "react-icons/fa"
import * as styles from "../styles/footer.module.scss"
import addToMailchimp from "gatsby-plugin-mailchimp"

const Inputgroup = props => {
  return (
    <div>
      <label
        htmlFor={props.name}
        className={props.hide ? styles.hideElement : ""}
      >
        {props.label}
      </label>
      <input
        type={props.type}
        placeholder={props.placeholder}
        name={props.name}
        id={props.name}
        pattern={props.pattern}
        onChange={props.change ? props.change : null}
        required
      />
    </div>
  )
}

const Footer = () => {
  const [news, setNews] = useState({
    email: "",
    fields: {
      FNAME: "",
      LNAME: "",
    },
  })
  const [message, setMessage] = useState("")
  const handleSubmit = e => {
    e.preventDefault()
    addToMailchimp(news.email, news.fields) // listFields are optional if you are only capturing the email address.
      .then(data => {
        // I recommend setting data to React state
        // but you can do whatever you want (including ignoring this `then()` altogether)
        setMessage(data)
      })
      .catch(() => {
        // unnecessary because Mailchimp only ever
        // returns a 200 status code
        // see below for how to handle errors
      })
  }
  return (
    <footer className={styles.foot}>
      <div className="container">
        <div>
          <h3>Contact Us</h3>
          <p>
            <a
              href="https://goo.gl/maps/xqFrF5PbZWQJQpqi6"
              target="_blank"
              rel="noreferrer"
            >
              566 S. Haywood St., <br></br>Waynesville, NC 28786
            </a>
          </p>
          <p>
            <a href="mailto:info@fumc-waynesville.com">
              info@fumc-waynesville.com
            </a>
          </p>
          <p>
            <a href="tel:828-456-9475">828-456-9475</a>
          </p>
        </div>
        <div>
          <h3>Weekly Services</h3>
          <h4>Awakening Service</h4>
          <p>Sundays at 9am</p>
          <h4>Traditional Service</h4>
          <p>Sundays at 11am</p>
        </div>
        <div className={styles.social}>
          <h3>Stay Connected</h3>
          <a
            href="https://www.youtube.com/fumcwaynesville"
            target="_blank"
            rel="noreferrer"
            aria-label="First United Methodist Church Waynesville YouTube"
          >
            <FaYoutube />
          </a>
          <a
            href="https://www.facebook.com/fumcwaynesville/"
            target="_blank"
            rel="noreferrer"
            aria-label="First United Methodist Church Waynesville Facebook"
          >
            <FaFacebook />
          </a>
          <a
            href="https://www.instagram.com/fumcwaynesville/"
            target="_blank"
            rel="noreferrer"
            aria-label="First United Methodist Church Waynesville Instagram"
          >
            <FaInstagram />
          </a>
          <a
            href="https://podcasts.apple.com/us/podcast/fumc-waynesville/id1371552900"
            target="_blank"
            rel="noreferrer"
            aria-label="First United Methodist Church Waynesville Pocasts"
          >
            <FaPodcast />
          </a>
          <a
            href="https://soundcloud.com/fumcwaynesville"
            target="_blank"
            rel="noreferrer"
            aria-label="First United Methodist Church Waynesville Soundcloud"
          >
            <FaSoundcloud />
          </a>

          <h4>Newsletter Sign Up</h4>
          <form onSubmit={e => handleSubmit(e, news.email)}>
            <fieldset>
              <legend className={styles.hideElement}>Name*</legend>
              <div>
                <Inputgroup
                  name={`firstname-footer`}
                  label={`First Name`}
                  type={`text`}
                  placeholder={"first name"}
                  hide={true}
                  change={e =>
                    setNews(prevState => ({
                      ...prevState,
                      fields: { ...prevState.fields, FNAME: e.target.value },
                    }))
                  }
                />
                <Inputgroup
                  name={`lastname-footer`}
                  label={`Last Name`}
                  type={`text`}
                  placeholder={"last name"}
                  hide={true}
                  change={e =>
                    setNews(prevState => ({
                      ...prevState,
                      fields: { ...prevState.fields, LNAME: e.target.value },
                    }))
                  }
                />
              </div>
            </fieldset>
            <Inputgroup
              name={`email-footer`}
              label={`Email*`}
              type={`email`}
              placeholder={"email"}
              pattern={`.+@.+..+`}
              change={e =>
                setNews(prevState => ({
                  ...prevState,
                  email: e.target.value,
                }))
              }
            />{" "}
            <button type="submit">
              Sign Up
            </button>{" "}
            <p
                dangerouslySetInnerHTML={{ __html: message.msg }}
                className={styles.subscribe}
              ></p>
          </form>
        </div>
        <div className={styles.copyright}>
          <p>
            © {new Date().getFullYear()} First United Methodist Church of Waynesville. All
            Rights Reserved.
          </p>
          <p>
            <a
              href="https://www.jonathanchawkins.com"
              target="_blank"
              rel="noreferrer"
            >
              Website by Jonathan Hawkins
            </a>
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
